import { Badge, type BadgeProps, cn } from '@sr/ui-library';

/**
 * Unread marker for the notification bell — a childless 8px dot rather than a
 * count. Positioned absolutely so each header can nudge it over its own bell
 * icon via `className`.
 */
export const NotificationDot = ({ className, ...props }: BadgeProps) => (
  <Badge
    className={cn(
      'absolute size-2 min-w-0 rounded-full border-none p-0',
      className,
    )}
    icon={null}
    variant="destructive"
    {...props}
  />
);
